import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TabItem from './TabItem';
import { margin, padding } from '../styleHelper2';

const StyledTabs = styled.ul`
  list-style: none;
  text-align: center;
  margin: 0;
  padding-left: ${props => props.theme.padding.small};
  padding-right: ${props => props.theme.padding.small};
  overflow: hidden;
  white-space: nowrap;
  ${margin()}
  ${padding()}
`;

const StyledTabItem = styled.li`
  display: inline-block;
`;

const defaultRender = data => <TabItem {...data} />;

const Tabs = ({ data, render, ...props }) => (
  <StyledTabs {...props}>
    {data.map((d, index) => (
      <StyledTabItem key={index.toString()}>{render(d, index)}</StyledTabItem>
    ))}
  </StyledTabs>
);

Tabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  render: PropTypes.func,
};

Tabs.defaultProps = {
  data: [],
  render: defaultRender,
};

export default Tabs;
